import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-personal-daily-report',
  templateUrl: './personal-daily-report.component.html',
  styleUrls: ['./personal-daily-report.component.scss']
})
export class PersonalDailyReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
